<template>
  <div>
    <page-header
      :page="page"
      :actions="pageActionConfig"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <div class="row">
      <div class="col-12">
        <Board v-if="studentDetails" :details="studentDetails" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <SectionTitle
          icon="fas fa-history"
          content="Historial de Enmienda"
          container-class="tag-badge-reverse my-2"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div
        v-for="(amendment, index) in history"
        :key="index"
        class="col-12 mb-2"
      >
        <div class="w-100 bg-secondary-3 rounded py-2 px-5">
          <div class="row">
            <div class="col-12 col-md-2 my-2 flex-column d-flex border-right-2">
              <span class="font-16">
                <strong>Enmendado:</strong>
              </span>
              <span class="font-16">
                <strong>{{ amendment.businessId }}</strong>
              </span>
            </div>

            <div class="col-12 col-md-2 my-2 flex-column d-flex pl-5">
              <label class="mb-0 font-title">Fecha:</label>
              <label class="mb-0 font-text">
                {{ formatDate(amendment.amendmentDate) }}
              </label>
            </div>
            <div class="col-12 col-md-7 my-2 flex-column d-flex">
              <label class="mb-0 font-title">Comentario:</label>
              <label class="mb-0 font-text">
                {{ amendment.comment }}
              </label>
            </div>
            <div
              class="col-12 col-md-1 my-2 flex-column d-flex align-items-end"
            >
              <action-button
                type="submit"
                text=""
                i="fa fa-file-download"
                variant="outline-success"
                class="px-1 mr-2 actions btn-width"
                @click="downloadFile(amendment.documentId)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import PageHeader from 'PageHeader';
import alertMixin from '@/mixin/alert.mixin';
import studentApi from '@/services/student.js';
import Board from 'Board';
import { getAmendmentHistory } from './_api';
import months from '@/utils/constants/months';
import _generalService from '@/services/pei/general';
import ActionButton from 'ActionButton';

export default {
  name: 'AmendmentHistory',
  components: {
    PageHeader,
    Board,
    SectionTitle,
    ActionButton,
  },
  mixins: [alertMixin],
  data: () => ({
    page: {
      icon: 'fas fa-user-edit',
      title: 'Historial de Enmienda',
      routes: [
        'Inicio',
        'PEI',
        'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        'Historial de Enmienda',
      ],
    },
    history: [],
    student: null,
  }),
  computed: {
    pageActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
      ];
    },
    studentDetails() {
      if (!this.student) return;
      return [
        [
          {
            label: 'Estudiante',
            data: this.student.fullName,
            icon: 'fas fa-address-book',
          },
          {
            label: 'Número SIE',
            data: this.student.studentId,
            icon: 'fas fa-clipboard-list-check',
          },

          {
            label: 'Escuela',
            data: `${this.student.schoolCode} - ${this.student.schoolName}`,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Impedimento',
            data: this.student.impediment,
            icon: 'fas fa-clipboard-list-check',
          },
        ],
      ];
    },
    studentSie() {
      return this.$route.params.studentSIE;
    },
    requestId() {
      return this.$route.params.tapRequestId;
    },
  },
  methods: {
    async getStudent(sie) {
      const { data } = await studentApi.getBySie(sie);
      this.student = data;
    },
    async getAmendmentHistory(requestId) {
      const { data } = await getAmendmentHistory(requestId);
      this.history = data;
    },
    formatDate(value) {
      const date = new Date(value).toLocaleDateString('es-ES').split('/');
      return `${date[0]}/${months[date[1] - 1]}/${date[2]}`;
    },
    downloadFile(id) {
      if (id) {
        _generalService.downloadDocumentByAttachmentId(id);
      }
    },
  },
  async created() {
    await Promise.all([
      this.getStudent(this.studentSie),
      this.getAmendmentHistory(this.requestId),
    ]);
  },
};
</script>
<style scoped>
.border-right-2 {
  border-right: 1px solid rgba(114, 114, 114, 0.22);
}
.btn-width {
  width: 50%;
}
.font-title {
  font-size: 14px;
  opacity: 1;
  color: #727272;
}
.font-text {
  font-size: 16px;
  opacity: 1;
  color: #11291b;
}
.font-16 {
  font-size: 16px;
  color: #182f22;
}
</style>
